<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-modal-print
                            ref="print"
                            @close-method="(file_name = null), $refs.print.close()"
                            :file-name="file_name"
                            :no-button="true"
                        ></bc-modal-print>
                        <bc-btn-refresh
                            v-if="options_category.category_id && options_category.category_id > 0"
                            @invoke-method="dbGetOptionsCategory(true)"
                        ></bc-btn-refresh>
                        <bc-btn-refresh
                            v-if="options_category.system_list && options_category.system_list > 0"
                            @click="$refs.delete_options_category.openDialog()"
                        ></bc-btn-refresh>
                        <v-menu left content-class="no-stripe" v-if="options_category.category_id && options_category.category_id > 0">
                            <template slot="activator">
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <template v-if="options_categories.system_list == 0">
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile @click="$refs.delete_options_category.openDialog()">
                                        <v-list-tile-title> Delete </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-menu>
                        <bc-tooltip>
                            <template slot="activator">
                                <v-btn icon @mouseup.left="$router.push({ name: 'options_categories' })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            {{ $t("lang.back_to_list") }}
                        </bc-tooltip>
                    </v-toolbar>
                </v-layout>
            </v-container>

            <v-card-text>
                <v-card>
                    <v-card-text>
                        <v-form ref="formOptionsCategory">
                            <v-flex xs12>
                                <v-text-field
                                    v-model="options_category.category_id"
                                    :label="$t('lang.category_id')"
                                    :counter="showCounter(options_category.category_id, 'options_categories.category_id')"
                                    :rules="ifValid('options_categories.category_id')"
                                    v-readonly-click
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="options_category.category"
                                    :label="`${$t('lang.category')} *`"
                                    :counter="showCounter(options_category.category, 'options_categories.category')"
                                    :rules="ifValid('options_categories.category')"
                                    v-readonly-click
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-switch
                                    v-model="options_category.system_list"
                                    :label="`${$t('lang.system_list')} *`"
                                    :rules="ifValid('options_categories.system_list')"
                                ></v-switch>
                            </v-flex>
                            <v-flex xs12>
                                <v-switch
                                    v-model="options_category.status"
                                    :label="`${$t('lang.status')} *`"
                                    :rules="ifValid('options_categories.status')"
                                ></v-switch>
                            </v-flex>

                            <div>
                                <v-data-table
                                    :headers="headers"
                                    :items="options_category.options || []"
                                    item-key="option_id"
                                    :no-data-text="$t('lang.no_results_matching')"
                                    hide-actions
                                >
                                    <template slot="items" slot-scope="props">
                                        <tr>
                                            <td>
                                                <v-flex xs12>
                                                    <v-text-field v-model="props.item.option_id" readonly></v-text-field>
                                                </v-flex>
                                            </td>
                                            <td>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        v-model="props.item.option"
                                                        :counter="showCounter(options_category.options.option, 'options.option')"
                                                        :rules="ifValid('options_categories.options.option')"
                                                    ></v-text-field>
                                                </v-flex>
                                            </td>
                                            <td>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        v-model="props.item.value"
                                                        :counter="showCounter(options_category.options.value, 'options.value')"
                                                        :rules="ifValid('options_categories.options.value')"
                                                    ></v-text-field>
                                                </v-flex>
                                            </td>
                                            <td>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        v-model="props.item.slug"
                                                        :counter="showCounter(options_category.options.slug, 'options.slug')"
                                                        :rules="ifValid('options_categories.options.slug')"
                                                    ></v-text-field>
                                                </v-flex>
                                            </td>
                                            <td>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        v-model="props.item.class"
                                                        :counter="showCounter(options_category.options.class, 'options.class')"
                                                        :rules="ifValid('options_categories.options.class')"
                                                    ></v-text-field>
                                                </v-flex>
                                            </td>
                                            <td>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        v-model="props.item.sort_order"
                                                        :counter="showCounter(options_category.options.sort_order, 'options.sort_order')"
                                                        :rules="ifValid('options_categories.options.sort_order')"
                                                    ></v-text-field>
                                                </v-flex>
                                            </td>
                                            <td>
                                                <v-icon @click="removeRow(props.index)">delete</v-icon>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                                <div class="text-center">
                                    <v-btn tile color="primary" @click="addRow()">{{ $t("lang.add_more") }}</v-btn>
                                </div>
                            </div>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @mouseup.left="$router.push({ name: 'options_categories' })" flat>{{ $t("lang.cancel") }}</v-btn>
                        <v-btn color="success" @click="saveOptionsCategories">{{ $t("lang.save") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-text>

            <delete-confirmation-dialog
                ref="delete_options_category"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_options_category')"
                :message="$t('lang.delete_options_category_confirm')"
                @onConfirm="deleteOptionsCategories()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_options"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteOptionsCategoryDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],
            headers: [
                { text: this.$t("lang.option_id"), sortable: false, width: "5%" },
                { text: this.$t("lang.option"), sortable: false, width: "30%" },
                { text: this.$t("lang.value"), sortable: false, width: "30%" },
                { text: this.$t("lang.slug"), sortable: false, width: "15%" },
                { text: this.$t("lang.class"), sortable: false, width: "15%" },
                { text: this.$t("lang.sort_order"), sortable: false, width: "5%" },
                { text: "", width: "3%", sortable: false },
            ],
            formData: {},
            options_category: { options: [] },
            file_name: "",
            dbGetOptionsCategory: _.debounce(this.getOptionsCategory, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchOptionsCategory", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.options_category) {
                        this.options_category = this.assignObj2(data.options_category, this.rules_options_categories);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=options_category_status&sort_by=2",
                            method: "get",
                            stateProperty: "options_category_status_options",
                            dataProperty: "options",
                            commit: true,
                        });
                        this.refresh();
                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "options_categories", replace: true });
                    }
                });
        } else {
            this.refresh();
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchOptionsCategory", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.options_category) {
                        next((vm) => {
                            vm.options_category = vm.assignObj2(data.options_category, vm.rules_options_categories);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=options_category_status&sort_by=2",
                                method: "get",
                                stateProperty: "options_category_status_options",
                                dataProperty: "options",
                                commit: true,
                            });
                            vm.refresh();
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "options_categories", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.refresh();
                vm.finishLoader();
            });
        }

        /*store.dispatch("fetchSetting", {
            url: "options?slug=options_category_status&sort_by=2",
            method: "get",
            stateProperty: "options_category_status_options",
            dataProperty: "options",
            commit: true,
        });*/
    },
    computed: {
        ...mapState({
            rules_options_categories: (state) => state.options_categories.rules_options_categories,
            options_category_status_options: (state) => state.settings.options_category_status_options,
            options_categories: (state) => state.options_categories.options_categories,
            selectedOptionsCategory: (state) => state.options_categories.selectedOptionsCategory,
        }),
    },
    methods: {
        ...mapActions(["fetchOptionsCategory", "saveOptionsCategory", "deleteOptionsCategory", "printOptionsCategory"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        addRow() {
            if (!this.options_category.options) this.options_category.options = [];

            this.options_category.options.push({
                category_id: `${this.$route.params.id}`,
                option: "",
                value: "",
                slug: "",
                class: "",
                sort_by: "",
                sort_order: "",
                status: "",
            });
        },
        removeRow: function (index) {
            this.options_category.options.splice(index, 1);
        },
        getOptionsCategory(pg_refresh = false) {
            this.startLoader();

            this.fetchOptionsCategory({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.options_category) {
                    this.options_category = this.assignObj2(data.options_category, this.rules_options_categories);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printOptionsCategory({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.options_category) {
                    if (this.dev_mode) {
                        this.file_name = data.options_category.file_name;
                    } else {
                        this.$refs.print.printReport(data.options_category.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveOptionsCategories() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formOptionsCategory")) {
                    let body = this.prepForm(this.options_category, this.rules_options_categories);

                    this.saveOptionsCategory({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.options_category) {
                            this.$router.push({ name: "options_category", params: { id: data.options_category.category_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { category_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveOptionsCategories({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.options_category) {
                    this.options_category = this.assignObj2(data.options_category, this.rules_options_categories);
                }
            });
        },
        deleteOptionsCategories() {
            this.deleteOptionsCategory({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.$refs.delete_options.close();
                    this.validationOff();
                    this.$router.push({ name: "options_categories" });
                }
                this.toggleModalLoader(false);
            });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        async refresh(force = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchOptionsCategory({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.options_category) {
                        this.options_category = this.assignObj2(data.options_category, this.rules_options_categories);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            }

            this.finishLoader();
        },
    },
    created() {},
};
</script>
